<template>
  <div class="mvh100 page flex flex-col-reverse" style="">
    <div class="body flex-1 flex flex-col">
      <div class="emp"></div>
      <!-- 助力规则 -->
      <div class="rule-div flex flex-col-center color-b">
        <div class="rule text-ellipsis flex-1">助力规则：积惠多助力享免单的规则，以防做错，白拼助qweqweqwe</div>
        <div class="arrow">
          <img src="@/assets/help/arrow-right.png" mode="aspectFit" style="width:16px;height:16px;" />
        </div>
      </div>
      <!-- 助力人数 -->
      <div class="help-count flex flex-row-center flex-col-center font-16 color-b m-t-23">
        <div><img src="@/assets/help/l.png" mode="aspectFit" style="width:10px;height:10px;" alt=""></div>
        <div style="margin:0 6px;" class="font500">已有NN人助力</div>
        <div><img src="@/assets/help/r.png" mode="aspectFit" style="width:10px;height:10px;" alt=""></div>
      </div>
      <div class="m-t-23">
        <div class="avatar-div">
          <img v-for="item in 10" :key="item" src="@/assets/help/test.png" class="ava-img" mode="aspectFit" alt="">
          <img src="@/assets/help/add.png" class="ava-img" mode="aspectFit" alt="">
        </div>
      </div>
      <div class="bottom-btn flex flex-row-center">
        <i-btn text="立即邀请好友助力" @btn-click="handleClick(1)" btn-type="2"></i-btn>
        <i-btn class="m-l-10" text="分享至朋友圈" @btn-click="handleClick(2)" btn-type="3"></i-btn>
      </div>
    </div>
    <div class="head flex flex-col">
      <div class="times font-16 font500 color-white flex flex-row-center m-t-10">
        助力活动倒计时
      </div>
      <div class="goods m-t-10" v-show="false"></div>
      <div class="coupon m-t-10"></div>
    </div>
    <div class="fix-btn">
      <i-btn class="m-l-10" text="" @btn-click="handleClick(3)" btn-type="1" width="77" height="40"
        cus-class="flex-row-end"
       :cus-style="{fontSize:'14px !important',lineHeight:'38px','border-top-right-radius':0,'border-bottom-right-radius':0}">
        <span style="margin-right:6px;line-height:38px;">我的助力</span>
      </i-btn>
    </div>
  </div>
</template>
<script>
import iBtn from '@/components/i-btn.vue'
export default {
  components: { iBtn },
  data(){
    return {}
  },
  methods:{
    handleClick:function(t){
      if(t == 3){
        const param = {
          type:'my'
        }
        this.$navigateTo("help",param)
      }
    }
  }
}
</script>
<style lang="less">
.page{
  background: linear-gradient(180deg, #FA6339 0%, #FED180 100%);
  .head{
    .times{
      height: 28px;
    }
    .goods{
      margin: 0 13px;
      height: 101px;
      border-radius: 4px;
      background:#FFFFFF;
    }
    .coupon{
      margin: 0 auto;
      width: 303px;
      height: 127px;
      background: url(../../assets/help/coupon.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .body{
    // height: 447px;
    margin-top: -44px;
    background: url(../../assets/help/bottom-bg.png) no-repeat;
    background-size: 100% 100%;
    .emp{
      height: 50px;
    }
    .rule-div{
      font-size: 12PX;
      background: #FEF6E6;
      margin: 0 13px;
      height: 20px;
      margin-top: 25px;
      border-radius: 4px;
      .rule{
        margin-left: 9px;
        line-height: 20px;
      }
      .arrow{
        margin-right: 5px;
        width: 16px;
        height: 16px;
      }
    }
    .avatar-div{
      margin: 0 40PX;
      flex-wrap: wrap;
      .ava-img{
        height: 40px;
        width: 40px;
        margin-left: -5px;
        margin-bottom: 15px;
      }
      
    }
    .bottom-btn{
      margin-top: 54px;
    }
    
  }
}
.fix-btn{
  position: absolute;
  z-index: 999;
  bottom: 50px;
  right: 0;
}
.text-ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.color-b{
  color: #B4421F;
}
.m-t-23{
  margin-top: 23px;
}
.m-l-10{
  margin-left: 10px;
}
</style>